angular.
module("dx.webapp.jobs").
component("dxJobImportStudents", {
	templateUrl: "tmpl/jobs/job-import-students-component.html",
	controller: "DxJobImportStudentsController",
	controllerAs: "vm",
	bindings: {
		job: "<",
		node: "<",
	},
});
